import { Pipe, PipeTransform } from '@angular/core';
import { NgxDatePipe } from './ngx-date.pipe';
import { parseUtcDateTimeString } from '@shared/utils/date.utils';

/**
 * Formats API UTC date/time strings to then use local timezone
 */
@Pipe({
  name: 'ngxUtcDate',
})
export class NgxUtcDatePipe implements PipeTransform {
  constructor(private readonly ngxDate: NgxDatePipe) {}

  transform(
    value: string | Date | null | undefined,
    displayFormat?: Parameters<NgxDatePipe['transform']>[1]
  ): string {
    const date = parseUtcDateTimeString(value);
    if (!date) {
      return '';
    }
    return this.ngxDate.transform(date, displayFormat) ?? '';
  }
}
